import { Injectable } from '@angular/core';
import { Http, Jsonp } from '@angular/http';
import 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { VersionService } from '../services/version.service';
import { Config } from '../classes/config';

@Injectable()
export class LinksService {

   constructor(private _http: Http, private _jsonp: Jsonp, private ver: VersionService) { }

  get() {
    return this._http.get(`${Config.apiUrl}/Link?versionId=${this.ver.activeVersion()}&callback=JSONP_CALLBACK`)
      .map(resp => resp.json());
  }

  getRecitations() {
    console.log(this.ver.activeVersion());
    return this._http.get(`${Config.apiUrl}/Statenvoorstel?versionId=${this.ver.activeVersion()}&callback=JSONP_CALLBACK`)
      .map(resp => resp.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/services/links.service.ts